/**
 * The WITNESS block (Figma 4:2, ADR-0043): `WitnessBlock` is the band of the rail a measured row carries, the badge
 * that names it, the sentence of what the row needs (or who asked, or who signed) and the act beside it. Advisory,
 * so nothing here blocks a verdict. Pure presentation: words and an act in.
 */
import type { ReactNode } from 'react';
import { SPACE, TEXT, usePalette } from '../theme';
import { Chip, toneOf } from './chip';

export function WitnessBlock({ badge, words, action }: { badge: ReactNode; words: ReactNode; action: ReactNode }) {
  const p = usePalette();
  return (
    <section
      aria-label="Witness"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: SPACE.md,
        flexShrink: 0,
        padding: `${SPACE.cozy}px ${SPACE.wide}px`,
        borderTop: `1px solid ${p.hairline}`,
        boxSizing: 'border-box',
      }}
    >
      <Chip look={toneOf('waiting')} size="row">
        {badge}
      </Chip>
      <span style={{ flex: 1, minWidth: 0, fontSize: TEXT.control, color: p.inkSecondary, lineHeight: 'normal' }}>{words}</span>
      {action}
    </section>
  );
}
